<template>
  <div
    v-if="group && group[0].fields.specfeatureGroup"
    class="w-full lg:container features__table"
  >
    <ProductFeatureGroup
      v-for="(featureGroup, index) in group[0].fields.specfeatureGroup"
      :key="`feature-group-${index}`"
      :product="product"
      :length="length"
      :feature-group="featureGroup"
      :index="index"
      :expand-all="expanded"
      :group="group"
      :specs="specs"
      :activeProduct="activeProduct"
      :expand-inner="expandInnerAll"
    />
  </div>
</template>
<script>
import ProductFeatureGroup from "../components/ProductFeatureGroup.vue";
export default {
  components: {
    ProductFeatureGroup,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    activeProduct: {
      type: Object,
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
    globals: {
      type: Object,
      required: true,
    },
    group: {
      type: [Object, Array],
      required: true,
    },
    specs: {
      type: Boolean,
      required: false,
      default: false,
    },
    expandAll: {
      type: Boolean,
      required: false,
      default: false,
    },
    expandInner: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
